<template>
  <span style="white-space: nowrap">
    <template v-if="$props.value">
      {{ $props.value | pretty_numeric }}
    </template>
    <template v-else>0 </template>
    <i class="fal fa-ruble-sign" />
  </span>
</template>

<script>
export default {
  name: "UnitRub",

  props: {
    value: {
      default: 0,
      required: true,
      validator: prop => typeof prop === "number" || prop === null
    }
  }
};
</script>
